import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackLeadFormOpened.meta';

export type LeadFormTrigger =
  | 'plans_modal_v1_book_demo'
  | 'plans_modal_business'
  | 'plans_modal_enterprise'
  | 'credit_meter'
  | 'credit_popover'
  | 'credit_banner'
  | 'current_plan_upgrade_button';

export type UseTrackLeadFormOpenedParams = {
  plan: string;
  trigger: LeadFormTrigger | (string & {});
};

export const useTrackLeadFormOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackLeadFormOpened = useCallback(
    (params: UseTrackLeadFormOpenedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackLeadFormOpened };
};
